module.exports = __webpack_public_path__ + "Rainforest-kakao-fb9be5ed5c2536ecb734e5ee1ae47128.png";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/product-labels/Rainforest-kakao.png
// module id = 76
// module chunks = 0